module.exports = __webpack_public_path__ + "static/media/screenshot.36d32d2f.jpg";